import { useEffect, useState } from "react";
import { t } from "@/lib/i18n";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import Reveal from "@/components/Reveal";
import NewsCard from "@/components/NewsCard";
import { Skeleton } from "@/components/ui/skeleton";

export default function NewsPreview() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/news/feed", { params: { scope: "jaipur", topics: "all", days: 30, limit: 3 } })
      .then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, []);
  if (items && items.length === 0) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="news-preview-section">
      <Reveal className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
        <div>
          <div className="text-xs font-bold tracking-[0.2em] uppercase text-[var(--leaf)]">{t("Around Jaipur")}</div>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold">{t("What's happening locally")}</h2>
        </div>
        <Link to="/news" className="inline-flex items-center gap-2 font-semibold text-[var(--leaf-dark)] link-u" data-testid="news-preview-all-link">{t("All news & filters")} <ArrowRight size={16} /></Link>
      </Reveal>
      <div className="mt-10 grid md:grid-cols-3 gap-4">
        {items === null
          ? [0, 1, 2].map((i) => <Skeleton key={i} className="h-44 rounded-2xl" />)
          : items.map((it, i) => <Reveal key={it.link} delay={i * 80}><NewsCard item={t(it)} index={i} /></Reveal>)}
      </div>
    </section>
  );
}
